import React from 'react';
import styles from './UIGamePlayerInformationProgress.module.scss';
import clsx from 'clsx';
import { T, Tooltip } from '@colonist/ui';
import { UIGameCityImprovementTracker } from '../../../common/UIGameCityImprovementTracker/UIGameCityImprovementTracker.tsx';
import { VictoryPointType } from '@colonist/game-states';
import { VictoryPointStateReader } from '@colonist/game-base-types';
import IconDefender from '@static/images/icon_defender.svg';
import IconTrophy from '@static/images/icon_trophy.svg';
import IconArrowPlayerProfile from '@static/images/icon_arrow_player_profile.svg';
import IconLargestArmy from '@static/images/icon_largest_army.svg';
import IconLongestRoad from '@static/images/icon_longest_road.svg';
import IconLargestArmyHighlight from '@static/images/icon_largest_army_highlight.svg';
import IconLongestRoadHighlight from '@static/images/icon_longest_road_highlight.svg';
import IconSwords from '@static/images/icon_swords.svg';
import IconSwordsHighlight from '@static/images/icon_swords_highlight.svg';
const CityImprovementTracker = ({ cityImprovementState })=>/*#__PURE__*/ React.createElement(Tooltip, {
        className: styles.cityImprovements,
        content: /*#__PURE__*/ React.createElement("div", {
            className: styles.cityImprovementTooltip
        }, /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement(T, {
            id: "strings:game.tips.cityImprovementButton.body.0"
        })), /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement(T, {
            id: "strings:game.tips.cityImprovementButton.body.1"
        }))),
        menuClassName: styles.tooltipMenu,
        title: /*#__PURE__*/ React.createElement(T, {
            id: "strings:game.tips.cityImprovementButton.title"
        })
    }, /*#__PURE__*/ React.createElement(UIGameCityImprovementTracker, {
        cityImprovementState: cityImprovementState,
        className: styles.cityImprovementTracker
    }));
const LargestArmy = ({ knightDevelopmentCardsUsedCount, hasLargestArmy })=>/*#__PURE__*/ React.createElement(Tooltip, {
        className: styles.achievementItem,
        content: /*#__PURE__*/ React.createElement(T, {
            id: "strings:game.playerInformation.largestArmy.body"
        }),
        menuClassName: styles.tooltipMenu,
        title: /*#__PURE__*/ React.createElement(T, {
            id: "strings:game.playerInformation.largestArmy.title"
        })
    }, /*#__PURE__*/ React.createElement("img", {
        className: styles.icon,
        src: hasLargestArmy ? IconLargestArmyHighlight : IconLargestArmy
    }), /*#__PURE__*/ React.createElement("div", {
        className: styles.achievementCount
    }, knightDevelopmentCardsUsedCount));
const LongestRoad = ({ isCityAndKnightMode, longestRoadCount, hasLongestRoad, translationKeyContext })=>/*#__PURE__*/ React.createElement(Tooltip, {
        className: clsx(styles.achievementItem, {
            [styles.horizontal]: isCityAndKnightMode
        }),
        content: /*#__PURE__*/ React.createElement(T, {
            id: {
                key: 'strings:game.playerInformation.longestRoad.body',
                options: {
                    context: translationKeyContext
                }
            }
        }),
        menuClassName: styles.tooltipMenu,
        title: /*#__PURE__*/ React.createElement(T, {
            id: {
                key: 'strings:game.playerInformation.longestRoad.title',
                options: {
                    context: translationKeyContext
                }
            }
        })
    }, /*#__PURE__*/ React.createElement("img", {
        className: styles.icon,
        src: hasLongestRoad ? IconLongestRoadHighlight : IconLongestRoad
    }), /*#__PURE__*/ React.createElement("div", {
        className: styles.achievementCount
    }, longestRoadCount));
const ActiveKnights = ({ knightStrength, hasHighestKnightStrength })=>/*#__PURE__*/ React.createElement(Tooltip, {
        className: clsx(styles.achievementItem, styles.horizontal),
        content: /*#__PURE__*/ React.createElement(T, {
            id: "strings:game.playerInformation.knightStrength.body"
        }),
        menuClassName: styles.tooltipMenu,
        title: /*#__PURE__*/ React.createElement(T, {
            id: "strings:game.playerInformation.knightStrength.title"
        })
    }, /*#__PURE__*/ React.createElement("img", {
        className: styles.icon,
        src: hasHighestKnightStrength ? IconSwordsHighlight : IconSwords
    }), /*#__PURE__*/ React.createElement("div", {
        className: styles.achievementCount
    }, knightStrength));
const DefenderOfColonist = ({ playerState })=>{
    const victoryPointsFromDefenderOfColonist = VictoryPointStateReader.totalVictoryPointsOfType(playerState.victoryPointsState, [
        VictoryPointType.DefenderOfColonist
    ]);
    return /*#__PURE__*/ React.createElement(Tooltip, {
        className: clsx(styles.achievementItem, styles.horizontal),
        content: /*#__PURE__*/ React.createElement(T, {
            id: "strings:game.playerInformation.defenderOfColonist.body"
        }),
        menuClassName: styles.tooltipMenu,
        title: /*#__PURE__*/ React.createElement(T, {
            id: "strings:game.playerInformation.defenderOfColonist.title"
        })
    }, /*#__PURE__*/ React.createElement("img", {
        className: styles.icon,
        src: IconDefender
    }), /*#__PURE__*/ React.createElement("div", {
        className: styles.achievementCount
    }, victoryPointsFromDefenderOfColonist));
};
const ProgressCardVictoryPoint = ({ playerState })=>{
    const victoryPointsFromProgressCard = VictoryPointStateReader.totalVictoryPointsOfType(playerState.victoryPointsState, [
        VictoryPointType.ProgressCardVictoryPoint
    ]);
    return /*#__PURE__*/ React.createElement(Tooltip, {
        className: clsx(styles.achievementItem, styles.horizontal),
        content: /*#__PURE__*/ React.createElement(T, {
            id: "strings:game.playerInformation.progressCardVictoryPoint.body"
        }),
        menuClassName: styles.tooltipMenu,
        title: /*#__PURE__*/ React.createElement(T, {
            id: "strings:game.playerInformation.progressCardVictoryPoint.title"
        })
    }, /*#__PURE__*/ React.createElement("img", {
        className: styles.icon,
        src: IconTrophy
    }), /*#__PURE__*/ React.createElement("div", {
        className: styles.achievementCount
    }, victoryPointsFromProgressCard));
};
export const UIGamePlayerInformationProgress = ({ isCityAndKnightMode, cityImprovementState, translationKeyContext, isCurrentUser, knightDevelopmentCardsUsedCount, knightStrength, hasLargestArmy, longestRoadCount, hasLongestRoad, hasHighestKnightStrength, playerValidator })=>/*#__PURE__*/ React.createElement("div", {
        className: clsx(styles.container, {
            [styles.currentUser]: isCurrentUser
        })
    }, isCityAndKnightMode && /*#__PURE__*/ React.createElement("img", {
        className: styles.viewSwitch,
        src: IconArrowPlayerProfile
    }), isCityAndKnightMode && /*#__PURE__*/ React.createElement(CityImprovementTracker, {
        cityImprovementState: cityImprovementState
    }), !isCityAndKnightMode && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(LargestArmy, {
        hasLargestArmy: hasLargestArmy,
        knightDevelopmentCardsUsedCount: knightDevelopmentCardsUsedCount
    }), /*#__PURE__*/ React.createElement(LongestRoad, {
        hasLongestRoad: hasLongestRoad,
        isCityAndKnightMode: isCityAndKnightMode,
        longestRoadCount: longestRoadCount,
        translationKeyContext: translationKeyContext
    })), isCityAndKnightMode && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
        className: clsx(styles.horizontalAchievements, styles.view1)
    }, /*#__PURE__*/ React.createElement(LongestRoad, {
        hasLongestRoad: hasLongestRoad,
        isCityAndKnightMode: isCityAndKnightMode,
        longestRoadCount: longestRoadCount,
        translationKeyContext: translationKeyContext
    }), /*#__PURE__*/ React.createElement(ActiveKnights, {
        hasHighestKnightStrength: hasHighestKnightStrength,
        knightStrength: knightStrength
    })), /*#__PURE__*/ React.createElement("div", {
        className: clsx(styles.horizontalAchievements, styles.view2)
    }, /*#__PURE__*/ React.createElement(ProgressCardVictoryPoint, {
        playerState: playerValidator.state
    }), /*#__PURE__*/ React.createElement(DefenderOfColonist, {
        playerState: playerValidator.state
    }))));
